import axiosInstance from '../utils/setupAxios';

export function fetchMobileActivityLogs(params = {}) {
  return axiosInstance.get('/songs/admin/activity-logs', { params });
}

export function fetchMobileActivityLogById(id) {
  return axiosInstance.get(`/songs/admin/activity-logs/${id}`);
}

export function fetchMobileActivityFilters() {
  return axiosInstance.get('/songs/admin/activity-logs/filters');
}

export function fetchDeviceActivitySummary(params = {}) {
  return axiosInstance.get('/songs/admin/activity-logs/device-summary', { params });
}

export function fetchDeviceActivityTimeline(params = {}) {
  return axiosInstance.get('/songs/admin/activity-logs/device-timeline', { params });
}
